import { useEffect } from 'react';

import Head from 'next/head';

import { PostOrPage } from '@tryghost/content-api';

import * as S from './styles';

interface IGhostProps {
  content: PostOrPage;
}

function waitFor(variable: any, callback: () => void) {
  const interval = setInterval(function () {
    if (window[variable]) {
      clearInterval(interval);
      callback();
    }
  }, 200);
}

const GhostContent = ({ content }: IGhostProps) => {
  if (!content.html) {
    return null;
  }

  useEffect(() => {
    waitFor('Prism', () => {
      const codeBlocks = document.querySelectorAll('pre>code');
      codeBlocks.forEach((codeBlock) => {
        codeBlock.classList?.forEach((elClass) => {
          if (elClass.includes('data-line')) {
            const value = elClass.split('=')[1];
            codeBlock.parentElement?.setAttribute('data-line', value);
          }
        });
      });
      window.Prism.highlightAll();
    });
  }, []);

  // Make all the links open in new tab.
  useEffect(() => {
    [...document.querySelectorAll('.blogPostContainer a')].forEach((link) => {
      link.setAttribute('target', '_blank');
    });
  }, []);

  useEffect(() => {
    [...document.querySelectorAll('.blogPostContainer h2, h3, h4')].forEach((heading) => {
      heading.addEventListener('click', () => (window.location.hash = heading.id));
    });
  }, []);

  return (
    <>
      <Head>
        <script src='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/prism.min.js'></script>
        {/* To load all the needed languages */}
        <script src='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/plugins/autoloader/prism-autoloader.min.js'></script>
        {/* Theme */}
        <link
          rel='stylesheet'
          href='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/themes/prism-tomorrow.min.css'
        />

        {/* Line numbers plugin */}
        <script src='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/plugins/line-numbers/prism-line-numbers.min.js'></script>
        <link
          rel='stylesheet'
          href='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/plugins/line-numbers/prism-line-numbers.min.css'
        />

        {/* Line highlight plugin*/}
        <script src='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/plugins/line-highlight/prism-line-highlight.min.js' />
        <link
          rel='stylesheet'
          href='https://cdn.jsdelivr.net/npm/prismjs@1.29.0/plugins/line-highlight/prism-line-highlight.min.css'
        />
      </Head>

      <S.GhostContentContainer
        className='blogPostContainer'
        dangerouslySetInnerHTML={{ __html: content.html }}
      />
    </>
  );
};

export default GhostContent;
